import { Store } from '@ngrx/store';
import { each } from 'lodash';
import { SdcActionsService } from 'src/app/sdc/flux/sdc-actions.service';
import { LoadUsersSuccess } from './../../../../../ng2/store/actions/users-actions';

export class ManageUsersEditPermissionsModalCtrl {
  static $inject: string[] = ['$mdDialog', 'ids', 'User', '$q', 'ErrorModal', 'Store', 'sdcActions', '$stateParams'];

  // bindings

  // class properties
  numOfIds: number;

  constructor(
    private $mdDialog,
    private ids,
    private User,
    private $q,
    private ErrorModal,
    private store: Store<any>,
    private sdcActions: SdcActionsService,
    private $stateParams,
  ) {
    this.numOfIds = ids.length;
  }

  $onInit() {
    // find a way to remove
  }

  closeModal() {
    this.$mdDialog.hide();
  }

  updateUserPermissioning(delegatedRole) {
    if (delegatedRole) {
      const path = 'delegatedRole';
      const newValue = delegatedRole === 'null' ? null : delegatedRole;
      const promises = [];

      each(this.ids, id => {
        promises.push(this.User.singleUpdate(id, path, newValue));
      });

      this.$q
        .all(promises)
        .then(async () => {
          await this.syncState();

          this.$mdDialog.hide({
            ids: this.ids,
            delegatedRole: newValue,
          });
        })
        .catch(error => {
          // error updating at least one of the users
          this.ErrorModal.showAndRequireRefresh('Error Changing User Access Level', error);
        });
    }
  }

  // TODO: once all actions for Users exist in store, use that infrastructure
  // to keep states in sync (CM).
  async syncState() {
    const users = await this.User.getAllSchoolUsers(this.$stateParams.schoolId);
    const usersForSdcStore = this.User.getMinisForSdcStore(users);

    this.sdcActions.setAllSchoolUsers(usersForSdcStore);
    this.store.dispatch(new LoadUsersSuccess(users));
  }
}
